import _ from 'lodash';
import Collection from '@skyjs/collection';

const isValueDefined = ([, v]) => v;
const isParam = ([k]) => k.startsWith(':');

export default function getUrlParams(url, route) {
  return _.fromPairs(
    Collection.fromArray(_.zip(_.split(route, '/'), _.split(url, '/')))
      .filter(isValueDefined)
      .filter(isParam)
      .map(([k, v]) => [k.replace(':', ''), decodeURIComponent(v)])
  );
}
